import styled, { css } from 'styled-components';

import colors from 'utils/colors';

import { HeaderProps } from './interfaces';

export const HeaderStyles = css<HeaderProps>`
  letter-spacing: -0.3px;
  font-weight: ${props => props.fontWeight || 'normal'};
  color: ${colors.blueGrey};
  margin: 0;
  margin-block-start: 0;
  margin-block-end: 0;
`;
export const BaseComponent = styled.div<HeaderProps>`
  ${HeaderStyles};
`;

const H1 = styled(BaseComponent).attrs({
  as: 'h1'
})`
  font-size: 28px;
`;

const H2 = styled(BaseComponent).attrs({
  as: 'h2'
})`
  font-size: 22px;
`;

const H3 = styled(BaseComponent).attrs({
  as: 'h3'
})`
  font-size: 18px;
`;

export default {
  H1,
  H2,
  H3
};
